// extracted by mini-css-extract-plugin
export default {"Container":"SignOutButton_Container__2yMRQ"};